import { styled } from '@ringcentral/juno';
import { PrimaryButton } from '@/components/button';
import { ctaButtonSizeOnMobile, ctaButtonTextOnMobile } from '../ctaButton.sc';

export const BotButton = styled(PrimaryButton)`
  ${ctaButtonSizeOnMobile};

  [class~='MuiButton-label'] {
    ${ctaButtonTextOnMobile};
  }
`;
